import { diff_match_patch } from '@ws/shared/utils';

export interface IMergeResult {
  text: string;
  hasConflict: boolean;
}

export class TextMerger {
  private dmp: diff_match_patch;

  constructor() {
    this.dmp = new diff_match_patch();
    // Configure for better text merging
    this.dmp.Diff_Timeout = 1.0;
    this.dmp.Diff_EditCost = 4;
    this.dmp.Match_Threshold = 0.5;
    this.dmp.Match_Distance = 1000;
  }

  public merge(base: string, local: string, remote: string): IMergeResult {
    // 1. Create a patch from Base -> Remote
    const patches = this.dmp.patch_make(base, remote);

    // 2. Apply that patch to Local
    const [resultText, results] = this.dmp.patch_apply(patches, local) as [string, boolean[]];

    // 3. Check for failures (results is array of booleans)
    // If any patch failed to apply, we might flag a conflict
    // But usually DMP is good at fuzzy patching.
    // A 'false' in results means the patch didn't apply cleanly.
    const hasConflict = results.some((success: boolean) => !success);

    return {
      text: resultText,
      hasConflict,
    };
  }
}
